import { makeAutoObservable } from "mobx";
import {
  EmptyIllustrationImpl,
  IllustrationApi,
} from "../DTO/ServerResponseType/Illustration/Illustration";
import { CheckArgs } from "../utils/checks/CheckArgsWithoutThrow";
import illustrationServerClient from "../ServerClients/IllustrationServerClient";
import appStore from "./AppStore";
import { TaskIllustrationIdsDTOType } from "../DTO/ServerResponseType/Task/TaskIllustration";
import {
  IllustrationIdApi,
  isGettedIllustrationIdDTO,
} from "../DTO/ServerResponseType/Illustration/IllustrationId";

export class IllustrationStore {
  /**
   * Open or close dialog modal to create illustration
   */
  showCreateIllustration: boolean = false;

  /**
   * Create illustration with connect to the task
   */
  doAddIllustrationToTask: boolean = false;

  /**
   * Illustration to be added
   */
  illustration: IllustrationApi = new EmptyIllustrationImpl();

  /**
   * SRC to view illustration
   */
  illustrationSrc: string = "";

  constructor() {
    makeAutoObservable(this);
  }

  private resetState = () => {
    this.illustration = new EmptyIllustrationImpl();
    this.illustrationSrc = "";
    this.doAddIllustrationToTask = false;
  };

  onCreateIllustrationModalOpen = () => {
    this.resetState();
    this.showCreateIllustration = true;
  };

  onCreateIllustrationModalClose = () => {
    this.showCreateIllustration = false;
  };

  /**
   * Add image to store
   * @param event
   * @returns
   */
  addImageFromFileAsync = async (event: React.FormEvent<HTMLInputElement>) => {
    // File was not selected
    if (event.currentTarget.files === null) return;

    let illustrationFile = event.currentTarget.files[0];

    if (illustrationFile.type.includes("image")) {
      this.illustration.illustrationType = illustrationFile.type; // update illustration type
    } else {
      alert("Выберите изображение");
      return;
    }

    this.illustration.illustration = illustrationFile; // update illustration for save

    this.illustrationSrc = URL.createObjectURL(illustrationFile); // update src for user viewing
  };

  onChangeName = (event: React.FormEvent<HTMLInputElement>) => {
    this.illustration.illustrationName = event.currentTarget.value;
  };

  onChangeAuthor = (event: React.FormEvent<HTMLInputElement>) => {
    this.illustration.illustrationAuthor = event.currentTarget.value;
  };

  onChangeDoAddIllustrationToTask = (
    event: React.FormEvent<HTMLInputElement>
  ) => {
    this.doAddIllustrationToTask = event.currentTarget.checked;
  };

  /**
   * Create illustration
   * @returns
   */
  public createIllustrationAsync = async () => {
    let createIllustrationPromise;

    if (this.doAddIllustrationToTask) {
      if (
        CheckArgs.CheckNullOrUndefinedOrEmptyString(
          appStore.taskStore.task.taskId
        )
      ) {
        console.log("Task was not created");
        return;
      }

      createIllustrationPromise = illustrationServerClient
        .sendToCreateIllustrationWithConnectionToTaskAsync(
          this.illustration,
          appStore.taskStore.task.taskId!
        )
        .then((illustrationIds: TaskIllustrationIdsDTOType) => {
          appStore.taskStore.taskIllustrationsStore.pushIllustration(
            illustrationIds
          );

          return illustrationIds;
        });
    } else {
      createIllustrationPromise =
        illustrationServerClient.sendToCreateIllustrationAsync(
          this.illustration
        );
    }

    return createIllustrationPromise.then(
      (
        illustrationIds: TaskIllustrationIdsDTOType | IllustrationIdApi | null
      ) => {
        if (isGettedIllustrationIdDTO(illustrationIds)) {
          this.illustration.illustrationId = illustrationIds.illustrationId;
          appStore.illustrationsStore.pushIllustration(this.illustration);
        } else {
          alert("Произошла ошибка при сохранении иллюстрации");
        }
      }
    );
  };
}
